import { HELP_SCOPES, LANGUAGE_CODES, HELP_ARTICLE_STATUS, VALIDATION_KEYS } from "@fysaro/shared";
import { z } from "zod";

// Base compartida para evitar duplicar código
export const baseHelpCategorySchema = z.object({
  key: z.string().min(1, VALIDATION_KEYS.GENERIC.REQUIRED),
  scope: z.enum(HELP_SCOPES).default("TENANT"),
  icon: z.string().optional().nullable(),
  order: z.number().int().min(0).default(0),
  status: z.enum(HELP_ARTICLE_STATUS).default("ACTIVE"),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es"),
  name: z.string().min(1, VALIDATION_KEYS.GENERIC.REQUIRED).max(200),
  description: z.string().max(500).optional().nullable(),
});

export const createHelpCategorySchema = baseHelpCategorySchema;

export const updateHelpCategorySchema = baseHelpCategorySchema.partial().extend({
  id: z.string().uuid(),
});

export const helpCategoryTranslationSchema = z.object({
  id: z.string().uuid().optional().nullable(),
  helpCategoryId: z.string().uuid().optional().nullable(),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]),
  name: z.string().min(1, VALIDATION_KEYS.GENERIC.REQUIRED),
  description: z.string().max(500).optional().nullable(),
});